import config from '../config';

export const ApiHelper = {
  parseResponseWithTotal: async (delegate) => delegate.then(res => ({ data: res?.data, total: res.headers[config.totalCountHeader.toLowerCase()] }))
}